var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0919 5.9686C13.4493 5.19373 14.5506 5.19373 14.908 5.96861L16.5869 9.60837C16.7326 9.92417 17.0318 10.1416 17.3772 10.1826L21.3576 10.6545C22.205 10.755 22.5453 11.8024 21.9188 12.3817L18.976 15.1032C18.7207 15.3393 18.6064 15.6911 18.6741 16.0322L19.4553 19.9637C19.6216 20.8007 18.7307 21.448 17.986 21.0312L14.4884 19.0733C14.1849 18.9035 13.815 18.9035 13.5115 19.0733L10.0139 21.0312C9.2693 21.448 8.37834 20.8007 8.54464 19.9637L9.32581 16.0322C9.39359 15.6911 9.27928 15.3393 9.02394 15.1032L6.08112 12.3817C5.45462 11.8024 5.79493 10.755 6.64233 10.6545L10.6227 10.1826C10.9681 10.1416 11.2674 9.92417 11.4131 9.60837L13.0919 5.9686Z",
    stroke: "#050022",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.b08825753db8cbeb8960ba873164e405.svg";
export { ForwardRef as ReactComponent };